import { logEvent } from './supabase';

type BatchEvent =
  | 'batch_landing_view'
  | 'batch_upload_started'
  | 'batch_processed'
  | 'batch_auth_gate_shown'
  | 'batch_auth_converted'
  | 'batch_zip_downloaded'
  | 'batch_upsell_clicked';

export async function trackEvent(
  event: BatchEvent,
  userId?: string | null,
  metadata?: Record<string, any>
): Promise<void> {
  try {
    await logEvent(
      event as any,
      userId || null,
      null,
      null,
      navigator?.userAgent || null,
      { source_app: 'tools', ...metadata }
    );
  } catch {
    // Analytics should never break the user experience
  }
}
